// extracted by mini-css-extract-plugin
export default {"InfoText":"style_InfoText__jiK1I"};